import { NgModule } from '@angular/core';
import { StockAnalysisComponent } from './stock-analysis.component';
import { CommonModule } from '@angular/common';
import { DateISOStringPipeModule, MarkdownToHtmlPipeModule } from '@toro/common/shared/pipes';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { FooterModule } from '@toro/common/shared/components/footer/footer.module';
import { AlertMessageModule } from '@toro/common/shared/components/alert-message/alert-message.module';
import { HubNavModule } from '@toro/common/shared/components/hub-nav/hub-nav.module';
import { SvgIconModule } from '@toro/common/shared/components/svg-icon/svg-icon.module';

import { GlobalModule } from '../../global.module';
import { ComponentsModule } from '../../components/components.module';
import { StockCardsModule } from '../stock-cards/stocks-cards.module';

import { TooltipDirectiveModule } from '@toro/common/shared/directives';

@NgModule({
    imports: [
        HubNavModule,
        SvgIconModule,
        AlertMessageModule,
        FooterModule,
        CommonModule,
        RouterModule,
        StockCardsModule,
        DateISOStringPipeModule,
        MarkdownToHtmlPipeModule,
        GlobalModule,
        ComponentsModule,
        TooltipDirectiveModule,
        FormsModule,
        ReactiveFormsModule,
    ],
    declarations: [
        StockAnalysisComponent,
    ],
    exports: [
        StockAnalysisComponent,
    ],
})

export class StockAnalysisModule {}
